import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getServices = () => {
    return axiosPrivate.get(`/dashboard/api/v1/merchant-statement/services`)
}